import * as React from "react";
import { Grid, GridColumn, GridRow, Input } from "semantic-ui-react";
import "./project-new.css";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { DezoningProject, LandUsePlanChangeProject } from "../../../stores/project/project";

export default function LandUsePlanChangeNew({
                                                 municipalities,
                                                 keyValueStore
                                             }: {
    municipalities: Municipality[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridRow>
                    <GridColumn largeScreen={16} widescreen={8}>
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "municipalityName")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "municipalityName")}
                            inputElement={
                                <select name="municipality" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {municipalities.map((m) => (
                                        <option
                                            key={m.bfsNr}
                                            value={m.bfsNr}
                                        >
                                            {m.name}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "place")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "place")}
                            inputElement={<Input type="text" name="place"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "revision")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "revision")}
                            inputElement={
                                <select name="revision" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.revisionTypes.map((t) => (
                                        <option
                                            key={t.key}
                                            value={t.key}
                                        >
                                            {t.value}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "status")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "status")}
                            inputElement={
                                <select name="status" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.projectStatuses.map((s) => (
                                        <option
                                            key={s.key}
                                            value={s.key}
                                        >
                                            {s.value}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "governmentCouncilDecisionNr")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "governmentCouncilDecisionNr")}
                            inputElement={<Input type="text" name="governmentCouncilDecisionNr"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "ebageNr")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "ebageNr")}
                            inputElement={<Input type="text" name="ebageNr"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "enactmentDateDisplayText")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "enactmentDateDisplayText")}
                            inputElement={<MyDatePicker name="enactmentDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "targetArea")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "targetArea")}
                            inputElement={<Input type="number" name="targetArea"/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "compensationDeadlineDisplayText")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "compensationDeadlineDisplayText")}
                            inputElement={<MyDatePicker name="compensationDeadline"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "cmiDocumentsRawiPre")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "cmiDocumentsRawiPre")}
                            inputElement={<Input type="text" name="cmiNrRawiPre"/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "cmiDocumentsUwePre")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "cmiDocumentsUwePre")}
                            inputElement={<Input type="text" name="cmiNrUwePre"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "cmiDocumentsRawiApproved")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "cmiDocumentsRawiApproved")}
                            inputElement={<Input type="text" name="cmiNrRawiApproved"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "cmiDocumentsUweApproved")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "cmiDocumentsUweApproved")}
                            inputElement={<Input type="text" name="cmiNrUweApproved"/>}
                        />
                    </GridColumn>
                    <GridColumn>
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "geometrySource")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "geometrySource")}
                            inputElement={<Input type="text" maxLength={50} name="geometrySource"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandUsePlanChangeProject.prototype, "geometrySourceDateDisplayText")}
                            desc={getDesc(LandUsePlanChangeProject.prototype, "geometrySourceDateDisplayText")}
                            inputElement={<MyDatePicker name="geometrySourceDate"/>}
                        />
                        <LabeledTextArea label={getLabel(LandUsePlanChangeProject.prototype, "remarks")}
                                         name="remarks"/>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    )
        ;
}
